<div class="container container-shadow my-3 py-4 px-3">
	<h3>
		<div class="row">
			<div class="col-md-3 col-sm-4 col-12">
				Linked Accounts
			</div>
			<div class="col-md-3 col-sm-4 col-12">
				<app-form-text-input placeholder="Search by name" [small]="true" [(model)]="nameFilter" (modelChange)="applyNameFilter()"></app-form-text-input>
			</div>
		</div>
	</h3>
	<div class="alert alert-info">
		Human user accounts are associated automatically by SSN. SSNs are not displayed. Accounts without an SSN are not associated.
	</div>
	<app-page-loader [loading]="pageLoading">
		<table class="table">
			<thead>
				<th>Person</th>
				<th>Associated Intranets</th>
				<th>Status</th>
			</thead>
			<tbody>
				<tr *ngFor="let linkedAccount of filteredLinkedAccounts">
					<td>{{linkedAccount.user_name}}</td>
					<td>{{linkedAccount.intranet_names.join(' ↔ ')}}</td>
					<td><span *ngIf="!linkedAccount.ambiguous" class="badge badge-success">Matched by SSN</span><span *ngIf="linkedAccount.ambiguous" class="badge badge-danger">Ambiguous</span></td>
				</tr>
			</tbody>
		</table>
	</app-page-loader>
</div>
